import React, { Suspense, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'
import { LinearProgress } from '@mui/material'

export function renderRoutes(routes = []) {
  const RouteWrapper = ({
    component: Component,
    guard: Guard,
    layout: Layout,
    layoutTitle,
    props,
    ...rest
  }) => {
    return (
      <Guard>
        <Layout title={layoutTitle}>
          <Route {...rest}>
            <Component {...props} />
          </Route>
        </Layout>
      </Guard>
    )
  }

  return (
    <Suspense fallback={<LinearProgress />}>
      <Switch>
        {routes.map((route, idx) => {
          const Component = route.component
          const Layout = route.layout
          const Guard = route.guard || Fragment
          return (
            <RouteWrapper
              key={idx}
              path={route.path}
              exact
              guard={Guard}
              component={Component}
              layout={Layout}
              layoutTitle={route.layoutTitle}
              props={route.props}
            />
          )
        })}
      </Switch>
    </Suspense>
  )
}
